export default __webpack_public_path__ + "static/media/sep.8df12dde.png";